var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mg-container"},[_vm._t("default"),_c('div',{staticClass:"table-content"},[_vm._t("table")],2),(_vm.$slots.footer)?_c('div',{staticClass:"mg-container-footer"},[_vm._t("footer")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }